<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="min-height: 80%">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Invoices</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-grouped">
          <p class="control is-expanded">
            <label class="label">Payment Status</label>
            <select name="payment" id="payment" v-model="invoice.payment" class="select is-fullwidth">
              <option value="">None</option>
              <option value="2">Billed</option>
              <option value="3">Pending</option>
              <option value="4">Legal Pending</option>
              <option v-if="this.showBoleto" value="5">Boleto</option>
            </select>
          </p>
          <p class="control is-expanded">
            <label class="label">Deadline</label>
            <datepicker ref="deadline" placeholder="Date"></datepicker>
          </p>
        </div>
        <div class="control is-grouped">
          <v-select
            :options="parsePaymentMethodSelect(payment_methods)"
            placeholder="Search Payment Method"
            label="name"
            max-height="100px"
            v-model="invoice.payment_method"
            v-if="payment_methods"
            style="width: 100%"
          >
          </v-select>
        </div>
        <p class="control is-expanded">
          <label class="label">Observações</label>
          <textarea class="input" type="textarea" name="comments" id="comments" placeholder="Inserir observações relevantes" v-model.trim="invoice.comments" style="min-height: 100px;"></textarea>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || error !== '', 'is-loading': inProgress}" @click="save()">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  import Datepicker from 'vue-bulma-datepicker'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      invoice_id: {
        type: Array,
        required: true
      },
      agencies_boleto: {
        type: Array,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        invoice: {
          invoice_id: [],
          payment: '',
          deadline: '',
          payment_method: '',
          pre_payment_method: '',
          comments: ''
        },
        showBoleto: true,
        inProgress: false,
        error: '',
        file: null,
        file2: null,
        payment_methods: null,
        remove_user_id: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.invoice.invoice_id = this.invoice_id
        this.agencies_boleto.forEach(boleto => {
          if (boleto === 0) {
            this.showBoleto = 0
          }
        })
        this.loadMethods()
      })
    },
    methods: {
      loadMethods () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/payment_methods', {params: { type: 0 }}).then((response) => {
          this.payment_methods = response.body
        }, (response) => {
        })
      },
      parsePaymentMethodSelect (methods) {
        let methodsTmp = methods.map((method) => {
          let methodName = ''
          if (parseInt(method.method_type) === 1) {
            methodName = method.card_number + ' - ' + method.card_flag + ' - CARD'
          } else {
            methodName = method.bank
            if (method.account !== null) {
              methodName = method.account + ' - ' + methodName
            }
            if (method.agency !== null) {
              methodName = method.agency + ' - ' + methodName
            }
            methodName += ' - BANK'
          }
          return {
            name: methodName,
            id: method.id
          }
        })
        return methodsTmp
      },
      close (closeOnly, result) {
        if (closeOnly) {
          this.remove_user_id = 1
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/set_editing_user', {invoice_id: this.invoice.invoice_id, remove_user_id: this.remove_user_id}).then((response) => {
          }, (response) => {
            this.error = response.body
          })

          this.context[this.callback](closeOnly)
        } else {
          this.context[this.callback](closeOnly)
        }
        this.remove_user_id = ''
        this.$el.remove()
      },
      async save () {
        this.inProgress = true
        if (window.confirm('Are you sure you want to edit?')) {
          this.invoice.deadline = this.$refs.deadline.datepicker.input.value
          this.error = ''
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/edit', this.invoice).then((response) => {
            this.inProgress = false
            this.close(false, 'ok')
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.inProgress = false
        }
      }
    },
    components: {
      Datepicker,
      babelPolyfill,
      vSelect
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// EditInvoice.vue?2ea90e0d